var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{staticStyle:{"width":"100%","image-rendering":"-webkit-optimize-contrast"},attrs:{"src":require("@/image/mian.png"),"alt":""}})])
}]

export { render, staticRenderFns }